import React from "react";
import PropTypes from "prop-types";
import { roundUp } from "LIB/formatters/number";

function dimension(fieldValue, label, placeholder) {
  return (
    <div className="col-md-4">
      <div>
        <label className="control-label sr-only" htmlFor={`${label}_cm`}>
          {placeholder}
        </label>
        <input
          type="number"
          min="0"
          value={fieldValue}
          disabled
          className="form-control"
          style={{ padding: "6px 4px" }}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
}

export default function CentimeterDimensions({
  length = 0,
  width = 0,
  height = 0
}) {
  return (
    <div className="form-group margin-bottom-none">
      <label className="control-label" htmlFor="dimensions">
        Dimensions in CM (L &times; W &times; H)
      </label>
      <div id="dimensions" className="row row-col-gutters-half">
        {dimension(roundUp(length * 2.54, 1) || null, "Length", "L")}
        {dimension(roundUp(width * 2.54, 1) || null, "Width", "W")}
        {dimension(roundUp(height * 2.54, 1) || null, "Height", "H")}
      </div>
    </div>
  );
}

CentimeterDimensions.propTypes = {
  length: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/shared/CentimeterDimensions.jsx